import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React from 'react';
import styled, { css } from '@xstyled/styled-components';
import { themePath, system } from '@trybeapp/ui.system';
import { Box } from '@trybeapp/ui.box';
import { Text } from '@trybeapp/ui.text';

var _excluded = ["children", "variant"],
  _excluded2 = ["children"];
var _templateObject, _templateObject2;
var StyledAlert = /*#__PURE__*/styled(Box)(function (_ref) {
  var variant = _ref.variant;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n    ", "\n  "])), themePath('alerts.default'), themePath("alerts." + variant), system);
});
var StyledTitle = /*#__PURE__*/styled(Text)(function () {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    ", ";\n\n    &:only-child {\n      margin-bottom: 0;\n    }\n\n    ", "\n  "])), themePath('alerts.title'), system);
});
var Alert = function Alert(_ref2) {
  var children = _ref2.children,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'error' : _ref2$variant,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledAlert, _extends({
    variant: variant
  }, rest), children);
};
var AlertTitle = function AlertTitle(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded2);
  return /*#__PURE__*/React.createElement(StyledTitle, props, children);
};
Alert.Title = AlertTitle;
AlertTitle.displayName = 'AlertTitle';
Alert.displayName = 'Alert';

export { Alert, AlertTitle };
